import {
  Accordion,
  AccordionItem,
  Box,
  Button,
  Card,
  Divider,
  Group,
  List,
  Textarea,
  Title,
  Text,
  Kbd,
  TextInput,
} from '@mantine/core';
import { Fragment } from 'react';
import { useConnectors } from 'utils/connectors';
import { TransformationEditor } from 'components/Editor/TransformationEditor';

export const IntegrationPreview = ({ api, setActive }) => {
  const { data } = useConnectors();
  const getConnector = (id: string) => {
    return data?.Connectors?.edges?.find?.(({ node }) => node.id === id)?.node?.name || id;
  };

  return (
    <Box>
      <Group
        style={{ margin: '15px 0px 10px 0px', display: 'flex', justifyContent: 'space-between' }}
      >
        <Group style={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
          <Title order={5}>{api?.name}</Title>
        </Group>
        <Button onClick={() => setActive(0)} color="blue" variant="outline">
          Edit
        </Button>
      </Group>
      <Divider />
      <Box style={{ marginTop: '20px' }}>
        <Textarea value={api?.description} readOnly label="API Description" />

        <Accordion iconPosition="right" style={{ margin: '10px 0px' }}>
          <AccordionItem label="Transformation">
            <TransformationEditor withFormik={false} name="" value={api?.transformation} readOnly />
          </AccordionItem>
        </Accordion>
        <Title order={5}>Endpoints</Title>
        <List
          withPadding
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, 1fr)',
            margin: '10px 0px',
          }}
        >
          <Fragment>
            {api?.endpoints?.map?.(endpoint => {
              return (
                <Card>
                  <Text weight={500}>
                    Connector:
                    <Kbd>{getConnector(endpoint.connectorId)}</Kbd>
                  </Text>
                  <Text style={{ margin: '8px 0px' }} weight={500}>
                    URI: <Kbd>{endpoint.uri}</Kbd>
                  </Text>
                  <Text weight={500}>Method: {endpoint.method}</Text>
                  <Box style={{ margin: '15px 0px' }}>
                    <Text weight={500}>Endpoint's Variables</Text>
                    {endpoint?.variables?.map?.(variable => (
                      <Group>
                        <TextInput label="Name" value={variable?.name} readOnly />
                        <TextInput label="Type" value={variable?.type} readOnly />
                        <TextInput label="DataType" value={variable?.dataType} readOnly />
                        <TextInput label="Value" value={variable?.value} readOnly />
                      </Group>
                    ))}
                  </Box>
                </Card>
              );
            })}
          </Fragment>
        </List>
        <Divider style={{ margin: '20px 0px' }} />
        <Title order={5}>Additional Resolvers</Title>

        {api?.additionalResolvers?.length ? (
          <List
            withPadding
            style={{
              display: 'grid',
              margin: '20px 0px',
            }}
          >
            <Fragment>
              {api?.additionalResolvers?.map?.((resolver, resolverIndex) => {
                return (
                  <Box>
                    <TextInput label="Resolver Type" value={resolver.type} readOnly />
                    <Accordion style={{ margin: '15px 0px' }}>
                      <AccordionItem label="Resolver Transformation">
                        <TransformationEditor
                          withFormik={false}
                          placeholder="Resolver Transformation"
                          name=""
                          value={resolver.transformation}
                          readOnly
                        />
                      </AccordionItem>
                    </Accordion>

                    <Title order={5}>Endpoints</Title>
                    <List
                      withPadding
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, 1fr)',
                        margin: '10px 0px',
                      }}
                    >
                      <Fragment>
                        {api?.additionalResolvers?.[resolverIndex]?.endpoints?.map?.(endpoint => {
                          return (
                            <Card style={{ margin: '15px 0px' }}>
                              <Text weight={500}>
                                Connector:
                                <Kbd>{getConnector(endpoint.connectorId)}</Kbd>
                              </Text>
                              <Text style={{ margin: '8px 0px' }} weight={500}>
                                URI: <Kbd>{endpoint.uri}</Kbd>
                              </Text>
                              <Text weight={500}>Method: {endpoint.method}</Text>
                              <Box style={{ margin: '15px 0px' }}>
                                <Text weight={500}>Endpoint's Variables</Text>
                                {endpoint?.variables?.map?.(variable => (
                                  <Group>
                                    <TextInput label="Name" value={variable?.name} readOnly />
                                    <TextInput label="Type" value={variable?.type} readOnly />
                                    <TextInput
                                      label="DataType"
                                      value={variable?.dataType}
                                      readOnly
                                    />
                                    <TextInput label="Value" value={variable?.value} readOnly />
                                  </Group>
                                ))}
                              </Box>
                            </Card>
                          );
                        })}
                      </Fragment>
                    </List>
                    <Divider style={{ margin: '25px 0px' }} />
                  </Box>
                );
              })}
            </Fragment>
          </List>
        ) : (
          <Text>No Resolvers</Text>
        )}
      </Box>
    </Box>
  );
};
